export const HTML_OPEN: string = 'offcanvas__html--open';
